module.exports = __webpack_public_path__ + "img/notice.a25bc322.jpg";